import { useAppDispatch } from "@/store";
import endpoints from "@/api/endpoints";
import httpClient from "@/api/http-client";
import { Product } from "@/models/category";
import { authActions, selectAuth } from "@/store/slices/auth";
import { fetchCartItems, selectCart } from "@/store/slices/cart";
import cart from "../../assets/images/cart1.svg";
import tryon from "../../assets/images/tryon3.svg";
import { GA4_ITEM_BRAND } from "@/lib/ga4";
import styles from "@/styles/product_list.module.scss";
import Tippy from "@tippyjs/react";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import fast from "../../assets/images/fast.svg";
import similar from "../../assets/images/simill.svg";
import CurrencyInr from "../common/currency-inr";
import LoadingSpinner from "../common/loading-spinner";
import LoadingSpinnerSmall from "../common/loading-spinner-small";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import { fetchWishlistItems, selectWishlist } from "@/store/slices/wishlist";
import { fbqTrackEvent } from "@/lib/fpixel";
import { ptrackEvent } from "@/lib/ppixel";
import { initTryOnEventListener } from "@/lib/tryOnTracking";
import { syteTrackEvent } from "@/lib/syte";
import { S3ImageLoader } from "@/image-loaders/s3-image-loader";
import { toTitleCase } from "@/utils/text-methods";
import SimilarProduct from "../similar-product/similar-product";
import { unbxdCusEngTrackEvent } from "@/lib/unbxd";

type ProductCardPropsType = {
  product: Product;
};

const ProductCardUnbxd = ({ product }: any) => {
  const dispatch = useAppDispatch();
  const [cartAddLoading, setCartAddLoading] = useState(false);
  const [cartRemoveLoading, setCartRemoveLoading] = useState(false);
  const [wishlistActionLoading, setwishlistActionLoading] = useState(false);
  const [actionData, setActionData] = useState({ type: "", id: "" });
  const cartState = useSelector(selectCart);
  const wishlistState = useSelector(selectWishlist);
  const authState = useSelector(selectAuth);
  const actionInProgress = useRef(false);
  const [tryOnAddToCart, setTryOnAddToCart] = useState(false);
  const [tryOnRemoveFromCart, setTryOnRemoveFromCart] = useState(false);
  const [similarLoading, setSimilarLoading] = useState(false);

  const [tags, setTags] = useState<any>(
    product.attributes?.find((v: any) => v.id === "tags")?.values[0]
      ?.value[0] || ""
  );

  const priceId = useMemo(
    () =>
      product.attributes?.find((v: any) => v.id === "price_id")?.values[0]
        ?.value[0],
    [product.attributes]
  );

  const cartItem = useMemo(
    () =>
      cartState.items.find((v) => v.identifier === product.defaultVariantId) ||
      null,
    [cartState.items, product.defaultVariantId]
  );

  const wishlistItem = useMemo(
    () => wishlistState.items.find((v) => v.id == product.productId) || null,
    [wishlistState.items, product.productId]
  );

  const addToCart = async () => {
    if (cartAddLoading) return;
    if (!authState.user) {
      dispatch(authActions.setIsModalOpen(true));
      setActionData({ type: "cart", id: product.defaultVariantId });
      sessionStorage.setItem(
        "add-to-cart-or-wishlist-id",
        product.defaultVariantId
      );
      return;
    }
    setCartAddLoading(true);
    try {
      await httpClient.post(endpoints.cart.add(), {
        is_solitaire: false,
        type: "product",
        identifier: product.defaultVariantId,
      });
      await dispatch(fetchCartItems());
      toast("Item added in cart", {
        type: "success",
        toastId: "cart-add-success",
      });
      fbqTrackEvent("AddToCart", {
        content_type: "product",
        content_ids: [product.sku],
      });
      ptrackEvent("addtocart", {
        event_id: `atc_${Date.now()}`,
        value: product.sellingPrice,
        order_quantity: 1,
        currency: "INR",
      });
      if (window.smartech) {
        unbxdCusEngTrackEvent("Add to cart ", {
          source: "web",
          platform: "senco",
          prid: product.productId,
          variant_id: product.defaultVariantId,
          image: product.imageUrl[0],
          prqt: 1,
          product_name: product.title,
          amount: product.sellingPrice,
          product_url: product.productUrl,
          discounted_price:
            product.sellingPrice !== product.price ? product.sellingPrice : 0,
          stock_availability: 1,
        });
      }
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: "INR",
          value: product.sellingPrice,
          items: [
            {
              item_id: product?.sku || product?.productId,
              item_name: product.title,
              item_brand: GA4_ITEM_BRAND,
              item_category: product.categories && product.categories.length ? [...product.categories].reverse()[0]?.name : "",
              item_variant: product.purity || product.attributes?.find((v: any) => v.id === "purity")?.values[0]?.value[0] || product.defaultVariantId,
              price: product.sellingPrice,
              quantity: 1,
            },
          ],
        },
      });
      // syteTrackEvent({
      //   name: "products_added_to_cart",
      //   tag: "ecommerce",
      //   osh_id: authState.user?.uuid,
      //   products: [
      //     {
      //       sku: product.sku[0],
      //       price: product.sellingPrice,
      //       quantity: 1,
      //     },
      //   ],
      // });
    } catch (error) {}
    setCartAddLoading(false);
  };
  const [show, setShow] = useState(false);
  const [skus, setskus] = useState<any>([]);

  const handleClose = () => setShow(false);
  const handleShow = async () => {
    setSimilarLoading(true);

    const formdata = new FormData();
    formdata.append("image_url", product.imageUrl[0]);
    formdata.append("tags", process.env.NEXT_PUBLIC_SIMILAR_API_TAG || "");
    try {
      const { data } = await httpClient.post(
        endpoints.products.similarproduct(),
        formdata
      );
      const filteredImages = data.images.filter((v: any) => v.distance > 0.65);
      await setskus(filteredImages.map((v: any) => v.product_id));
      setShow(true);
    } catch (error: any) {
      toast(error.response.data?.message || "No products found", {
        type: "error",
        toastId: "coupon-otp-error",
      });
    } finally {
      setSimilarLoading(false);
    }
  };
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (tryOnAddToCart) {
      setTryOnAddToCart(false);
      addToCart();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tryOnAddToCart]);

  const removeFromCart = async (requireConfirmation = true) => {
    if (requireConfirmation) {
      if (!confirm("Are you sure you want to remove this product from cart?"))
        return;
    }
    setCartRemoveLoading(true);
    try {
      await httpClient.delete(endpoints.cart.remove(cartItem?.id));
      await dispatch(fetchCartItems());
      toast("Item removed from cart", {
        type: "info",
        toastId: "cart-remove-success",
      });
      if (window.smartech) {
        unbxdCusEngTrackEvent("Remove from cart ", {
          source: "web",
          platform: "senco",
          prid: product.productId,
          variant_id: product.defaultVariantId,
          image: product.imageUrl[0],
          prqt: 1,
          product_name: product.title,
          amount: product.sellingPrice,
          product_url: product.productUrl,
        });
      }
      if (product.categories && product.categories.length) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: "remove_from_cart",
          ecommerce: {
            currency: "INR",
            value: product.discount ? product.discount.price : product.price,
            items: [
              {
                item_id: product?.sku,
                item_name: product.title,
                item_category: [...product.categories].reverse()[0].name,
                price: product.discount
                  ? product.discount.price
                  : product.price,
                quantity: 1,
              },
            ],
          },
        });
      }
    } catch (error) {
      console.log(error);
    }
    setCartRemoveLoading(false);
  };

  useEffect(() => {
    if (tryOnRemoveFromCart) {
      setTryOnRemoveFromCart(false);
      removeFromCart(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tryOnRemoveFromCart]);

  const openTryOn = () => {
    if (window.initMirrarUI && process.env.NEXT_PUBLIC_STYLEDOTME_BRAND_ID) {
      initTryOnEventListener((name, data) => {
        if (name == "add-to-cart") {
          if (data.productCode == String(product.sku).toUpperCase()) {
            setTryOnAddToCart(true);
          }
        }
        if (name == "ProductRemoveFromCart") {
          if (data.productCode == String(product.sku).toUpperCase()) {
            setTryOnRemoveFromCart(true);
          }
        }
      });
      window.initMirrarUI(String(product.sku).toUpperCase(), {
        brandId: process.env.NEXT_PUBLIC_STYLEDOTME_BRAND_ID,
      });
      if (product.categories && product.categories.length) {
        window.gtag("event", "tryon-button-click", {
          event_category: "mirrar-internal-event",
          event_label: `${[...product.categories].reverse()[0].name}/${
            product.sku
          }/${product.discount ? product.discount.total : product.price}`,
        });
      }
    }
  };

  const addToWishlist = async () => {
    if (wishlistActionLoading) return;
    if (!authState.user) {
      dispatch(authActions.setIsModalOpen(true));
      sessionStorage.setItem(
        "add-to-cart-or-wishlist-id",
        product.groupId ? product.groupId : product.productId
      );
      setActionData({
        type: "wishlist",
        id: product.groupId ? product.groupId : product.productId,
      });
      return;
    }
    setwishlistActionLoading(true);
    try {
      await httpClient.post(endpoints.wishlist.add(), {
        product_id: product.groupId ? product.groupId : product.productId,
        user_id: authState.user.id,
      });
      await dispatch(fetchWishlistItems(authState.user.id as any));
      toast("Item added in wishlist", {
        type: "success",
        toastId: "withlist-add-success",
      });
      fbqTrackEvent("AddToWishlist", {
        content_type: "product",
        content_ids: [product.sku[0]],
      });
      if (window.smartech) {
        unbxdCusEngTrackEvent("Add to wishlist ", {
          source: "web",
          platform: "senco",
          prid: product.groupId ? product.groupId : product.productId,
          variant_id: product.defaultVariantId,
          image: product.imageUrl[0],
          prqt: 1,
          product_name: product.title,
          amount: product.price,
          product_url: product.productUrl,
          discounted_price:
            product.sellingPrice !== product.price ? product.sellingPrice : 0,
          stock_availability: 1,
        });
      }
    } catch (error) {}
    setwishlistActionLoading(false);
  };

  const removeFromWishlist = async () => {
    if (wishlistActionLoading) return;
    if (!confirm("Are you sure you want to remove this product from wishlist?"))
      return;
    if (!authState.user) {
      dispatch(authActions.setIsModalOpen(true));
      return;
    }
    setwishlistActionLoading(true);
    try {
      await httpClient.post(endpoints.wishlist.remove(), {
        product_id: product.productId,
        user_id: authState.user.id,
      });
      await dispatch(fetchWishlistItems(authState.user.id as any));
      toast("Item removed from wishlist", {
        type: "success",
        toastId: "withlist-remove-success",
      });
    } catch (error) {}
    setwishlistActionLoading(false);
  };

  useEffect(() => {
    const handleAction = async () => {
      if (actionInProgress.current) return;

      if (actionData.id && authState.user) {
        actionInProgress.current = true;

        try {
          if (actionData.type === "cart") {
            await addToCart();
          } else if (actionData.type === "wishlist") {
            await addToWishlist();
          }
        } catch (error) {
          console.error("Error handling action:", error);
        } finally {
          setActionData({ type: "", id: "" });
          sessionStorage.removeItem("add-to-cart-or-wishlist-id");
          actionInProgress.current = false;
        }
      }
    };
    const cart_id = sessionStorage.getItem("add-to-cart-or-wishlist-id");
    if (`${actionData?.id}` === cart_id && authState.user) {
      handleAction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState, actionData]);

  return (
    <>
      {" "}
      <div
        className={`${styles.product} product-info-sku-variant`}
        data-sku={product.sku}
        data-variant-id={product.sku}
      >
        <div className={styles.pad_10}>
          <div className={styles.products_text_top}>
            <div className={styles.product_top_left}>
              {product.isBestSeller === "true" && (
                <div className={styles.best_seller}>BESTSELLER</div>
              )}
              {product.isNewArrival === "true" && (
                <div className={styles.new_arrival}>NEW ARRIVAL</div>
              )}
             
            </div>
            <div className={styles.cart_top}>
              {/* {product?.hasTryOnline === "true" && (
                <div className={styles.tryontext} onClick={openTryOn}>
                  <span>TryOn</span>
                </div>
              )} */}
              {product.variants[0]?.vIsFastDelivery &&
                product.variants[0]?.vIsFastDelivery === "true" && (
                  <Tippy content="Fast Delivery">
                    <div className={styles.fast_delivery}>
                      <Image
                        src={fast}
                        alt="Fast Delivery"
                        priority
                        unoptimized
                      />
                    </div>
                  </Tippy>
                )}
              {wishlistActionLoading && (
                <span style={{ position: "relative", top: -6 }}>
                  <LoadingSpinnerSmall />
                </span>
              )}
              {!wishlistActionLoading && (
                <>
                  {wishlistItem ? (
                    <Tippy content="Wishlisted">
                      <a className="pointer" onClick={removeFromWishlist}>
                        <FontAwesomeIcon
                          icon={faHeartSolid}
                          width={20}
                          color={"rgba(143, 0, 6, 1)"}
                          style={{ position: "relative", top: -8 }}
                        />
                      </a>
                    </Tippy>
                  ) : (
                    <Tippy content="Add To Wishlist">
                      <a className="pointer" onClick={addToWishlist}>
                        <FontAwesomeIcon
                          icon={faHeartRegular}
                          width={20}
                          color={"rgba(143, 0, 6, 1)"}
                          style={{ position: "relative", top: -8 }}
                        />
                      </a>
                    </Tippy>
                  )}
                </>
              )}
            </div>
          </div>
          <Link href={product.productUrl} passHref>
            <a target="_blank" rel="noopener noreferrer">
              <div className={styles.product_image}>
                <Image
                  src={product.imageUrl[0]}
                  alt={product.title}
                  width={2500}
                  height={2500}
                  className={styles.img_fluid}
                />
              </div>
            </a>
          </Link>
          <div className={`${styles.discount_container} ${product.discountLabel ? 'has-product-discount' : ''}`}>
            {/* {product.discountLabel ? (
              <div className={styles.discount_text}>
                {product.discountLabel}
              </div>
            ) : (
              <div className={styles.discount_text}>&nbsp;</div>
            )} */}
            <div className={styles.discount_text}>&nbsp;</div>
          </div>
          <div className={`${styles.similar_button_container_over} ${styles.center_single}`}>
          <button
            onClick={() => handleShow()}
            className={styles.similar_button}
          >
            {similarLoading ? (
              <div className={styles.buttonLoader}>
                <LoadingSpinner />
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "1",
                    marginLeft: "8px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Loading...
                </span>
              </div>
            ) : (
              <>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.15784 14.6486C2.55606 14.7333 1.43008 13.4626 1.35838 12.4253L0.607516 3.95596C0.50054 2.40826 1.8481 1.07773 3.61737 0.984153L8.43732 0.611263C10.0391 0.526541 11.3047 0.984153 11.6469 2.48291M13.4852 3.0382L7.5354 3.0382C5.81428 3.0382 4.41904 4.43489 4.41904 6.15779L4.41903 13.482C4.41903 15.2049 5.81428 16.6016 7.5354 16.6016H13.4852C15.2063 16.6016 16.6016 15.2049 16.6016 13.482L16.6016 6.1578C16.6016 4.43489 15.2063 3.0382 13.4852 3.0382Z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
</svg>
                <span className={styles.span}>Similar</span>
              </>
            )}
          </button>
          {/* {product?.hasTryOnline === "true" && <div className={styles.divd}>|</div>}
            {product?.hasTryOnline === "true" && (
                <div className={styles.tryontext} onClick={openTryOn}>
                   <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.703125 7.12943C0.703125 6.00535 1.61437 5.0941 2.73845 5.0941C3.50938 5.0941 4.21414 4.65853 4.55891 3.969L5.46001 2.16678C5.58072 1.92537 5.64107 1.80467 5.70951 1.69968C6.06659 1.1519 6.64925 0.791796 7.29889 0.717386C7.4234 0.703125 7.55835 0.703125 7.82826 0.703125H13.3374C13.6073 0.703125 13.7422 0.703125 13.8667 0.717386C14.5164 0.791796 15.099 1.1519 15.4561 1.69968C15.5246 1.80467 15.5849 1.92537 15.7056 2.16678L16.6067 3.969C16.9515 4.65853 17.6563 5.0941 18.4272 5.0941C19.5513 5.0941 20.4625 6.00535 20.4625 7.12943V12.6215C20.4625 14.8222 20.4625 15.9226 19.9577 16.7259C19.6945 17.1448 19.3403 17.499 18.9214 17.7622C18.118 18.267 17.0177 18.267 14.817 18.267H6.34866C4.14795 18.267 3.04759 18.267 2.24425 17.7622C1.82534 17.499 1.47112 17.1448 1.2079 16.7259C0.703125 15.9226 0.703125 14.8222 0.703125 12.6215V7.12943Z" stroke="currentColor" strokeWidth="1.4"/>
<path d="M14.9738 10.5828C14.9738 13.0079 13.0079 14.9738 10.5828 14.9738C8.15775 14.9738 6.19184 13.0079 6.19184 10.5828C6.19184 8.15775 8.15775 6.19184 10.5828 6.19184C13.0079 6.19184 14.9738 8.15775 14.9738 10.5828Z" stroke="currentColor" strokeWidth="1.4"/>
</svg>
                  <span className={styles.span}>TryOn</span>
                </div>
              )} */}
          </div>
          {/* <button
            onClick={() => handleShow()}
            className={styles.similar_button_mobile}
          >
            {similarLoading ? (
              <div className={styles.buttonLoader}>
                <LoadingSpinner />
              </div>
            ) : (
              <Image src={similar} alt="View Similar" />
            )}
          </button> */}
          {/* <button
            aria-label="PLP-button"
            className={`${styles.similar_button} syte-discovery`}
            data-image-src={product.mainImage}
            data-sku={product.sku[0]}
            data-placement="PLP-button"
            onClick={() => handleShow()}
          >
            <Image src={similar} alt="View Similar" />{" "}
            <span className={styles.text}>View Similar</span>
          </button>
          <button
            aria-label="PLP-button"
            className={`${styles.similar_button_mobile} syte-discovery`}
            data-image-src={product.mainImage}
            data-sku={product.sku[0]}
            data-placement="PLP-button"
            onClick={() => handleShow()}
          >
            <Image src={similar} alt="View Similar" />
          </button> */}
          <p className={styles.product_text_d}>{product.title}</p>
          <div className={styles.price_cart}>
            <div className={styles.price1}>
              <span>
                <CurrencyInr value={product.sellingPrice} />
              </span>
              <div className={styles.price2}>
                {product.sellingPrice !== product.price ? (
                  <span>
                    <CurrencyInr value={product.price} />
                  </span>
                ) : (
                  "\u00A0"
                )}
              </div>
            </div>

            {!cartItem && (
              <>
                {cartAddLoading && <LoadingSpinner />}
                {!cartAddLoading && (
                  <Tippy content="Add To Cart">
                    <a
                      className={`${styles.details} pointer`}
                      onClick={addToCart}
                    >
                      <Image
                        src={cart}
                        alt="Add To Cart"
                        width={26}
                        height={26}
                      />
                    </a>
                  </Tippy>
                )}
              </>
            )}

            {cartItem && (
              <>
                {cartRemoveLoading && <LoadingSpinner />}
                {!cartRemoveLoading && (
                  <Tippy content="Remove From Cart">
                    <a
                      className={`${styles.details} pointer`}
                      onClick={() => removeFromCart()}
                    >
                      <Image
                        src={cart}
                        alt="Add To Cart"
                        width={26}
                        height={26}
                      />
                    </a>
                  </Tippy>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <SimilarProduct
        show={show}
        handleClose={handleClose}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        image={product.imageUrl[0]}
        skus={skus}
        setskus={setskus}
      />
    </>
  );
};

export default ProductCardUnbxd;
